import { InjectionToken } from '@angular/core';

import { GoogleMapLibrary } from '../enums';

export const SN_GOOGLE_MAP_LIBRARY = new InjectionToken<GoogleMapLibrary>('SN_GOOGLE_MAP_LIBRARY');
